export const CALIBRATION_STATUSES = {
  VALID: 'valid',
  EXPIRED: 'expired',
  UNKNOWN: 'unknown',
}
